import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ServiceCard = ({ icon, title, description, link }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      transition={{ duration: 0.2 }}
      className="group"
    >
      <Link to={link} className="block">
        <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 h-full border border-gray-100 group-hover:border-accent-200">
          <div className="text-accent-500 mb-6 group-hover:text-accent-600 transition-colors duration-200">
            {icon}
          </div>
          
          <h3 className="text-xl font-bold text-primary-800 mb-4 group-hover:text-accent-600 transition-colors duration-200">
            {title}
          </h3>
          
          <p className="text-primary-600 leading-relaxed">
            {description}
          </p>
          
          <div className="mt-6 flex items-center text-accent-500 font-semibold group-hover:text-accent-600 transition-colors duration-200">
            <span>Learn more</span>
            <svg 
              className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-200" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ServiceCard;
